/**
 * Хук page_view (docs/service/37 §6.2). Нормализует путь до роут-паттерна
 * (`/clients/:id`, не `/clients/<uuid>`) через matchRoutes — иначе id клиента
 * попадёт в телеметрию (PII-связка + кардинальность).
 */
import { useEffect, useRef } from 'react';
import { matchRoutes, useLocation } from 'react-router-dom';

import { routes } from '@/routes';

import { trackPageView } from './track';

/** Собрать паттерн из веток совпадения (join непустых route.path). */
function normalizeRoute(pathname: string): string {
  try {
    const matches = matchRoutes(routes, pathname);
    if (!matches || matches.length === 0) return pathname;
    const parts: string[] = [];
    for (const m of matches) {
      const p = m.route.path;
      if (p && p !== '/') parts.push(p.replace(/^\//, ''));
    }
    const joined = '/' + parts.join('/');
    return joined.replace(/\/+/g, '/');
  } catch {
    return pathname;
  }
}

export function useTrackPageViews(): void {
  const { pathname } = useLocation();
  const last = useRef<string>('');
  useEffect(() => {
    const route = normalizeRoute(pathname);
    if (route === last.current) return;
    last.current = route;
    trackPageView(route);
  }, [pathname]);
}
